<template>
  <v-container grid-list-xs fluid>
    <!-- <h1>changhl</h1> -->
    <gh-progress :show="service.isBusy"></gh-progress>
    <v-layout column fixed>
      <v-form @submit.native.prevent>
        <v-layout row align-center>
          <slot name="query-bar">
            <v-text-field label='关键字' @keyup.enter.native='query' clearable @change="query" append-icon="search"
              @click:clear="query"></v-text-field>
          </slot>

          <v-spacer></v-spacer>
          <v-btn color='primary' @click.prevent='query'>刷新</v-btn>
          <slot name="query-actions">

          </slot>

        </v-layout>
      </v-form>
      <v-divider></v-divider>
      <gh-table :paginate-server-side="paginateServer" :headers='headers' :selectedItems.sync='selectedItems' :items='items'
        :total-items="totalItems" :pagination.sync='service.pagination' @copyItem='' @editItem='' @deleteItem=''>
        <template slot='title'>
          <slot name=tableTitle></slot>
        </template>
        <template v-slot:[item.value]="{props}" v-for="item in headers">
          <slot :name="'table-'+item.value" :props="props">
          </slot>
        </template>

      </gh-table>
    </v-layout>

  </v-container>

</template>

<style scoped>

</style>

<script>
  import GhDataView from "./ghDataView.ts";
  export default GhDataView;
</script>